// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3vNx2","largestCol":"styles_largestCol__1gI5j","smallestCol":"styles_smallestCol__3dOqy"};